// extracted by mini-css-extract-plugin
export var alignCenter = "_8n-d";
export var bannerShown = "_8n-6";
export var buttonContent = "_8n-0";
export var cardList = "_8n-1";
export var centerContent = "_8n-2";
export var chevron = "_8n-3";
export var closePanelButton = "_8n-k";
export var conversationContextContainer = "_8n-l";
export var conversationDetailContainer = "_8n-4";
export var detailWrapper = "_8n-7";
export var dropdownButton = "_8n-e";
export var dropdownTitle = "_8n-9";
export var fullHeight = "_8n-5";
export var hidden = "_8n-a";
export var icon = "_8n-b";
export var mergeSuggestionWrapper = "_8n-m";
export var panel = "_8n-i";
export var portalButtonsWrapper = "_8n-c";
export var right = "_8n-j";
export var tableSummaryContainer = "_8n-8";
export var tableSummaryHeader = "_8n-g";
export var threeDotsButton = "_8n-f";
export var wide = "_8n-h";